<template>
  <div class="choosecloudphone pointer">
    <NavBar title="选择云手机" />
    <div class="main">
      <van-checkbox-group
        v-model="result"
        ref="checkboxGroup"
        v-if="!showDialog && cloudphonelist.length >= 0"
      >
        <van-cell-group class="shebeiBox">
          <van-cell
            v-for="(item, index) in cloudphonelist"
            clickable
            :key="index"
            @click="toggle(index)"
            class="shebeiItem"
          >
            <template #title>
              <div class="shebei_title">
                <div class="shebei_content">
                  <p class="p1">{{ item.instanceName }}</p>
                  <div class="p2">
                    <img class="idIcon" src="@/assets/imgs/ID.png" alt="" />
                    <p class="id">{{ item.userInstanceId }}</p>
                  </div>
                </div>
                <div class="instanceItem">
                  剩余时间：{{ item.timeRemaining }}
                </div>
              </div>
            </template>
            <template #right-icon>
              <van-checkbox
                :name="item"
                ref="checkboxes"
                checked-color="#8572eb"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
      <van-empty
        v-if="!showDialog && cloudphonelist.length <= 0"
        class="custom-image"
        :image="require('@/assets/imgs/empty.png')"
        description="暂时没有续时的云手机哦！"
      />
    </div>
    <!--  v-if="continuation" -->
    <div class="footer">
      <div class="allChecked">
        <van-checkbox
          v-model="allChecked"
          @click="checkAll"
          checked-color="#8572eb"
          >全选</van-checkbox
        >
        <p>已选择{{ result.length }}台云手机</p>
      </div>
      <van-button
        class="jihuo"
        @click="wancheng"
        :disabled="result.length <= 0 ? true : false"
        :color="result.length <= 0 ? '#999' : '#886DF3'"
      >
        续时
      </van-button>
    </div>
    <generalConfirm
      :showDialog.sync="showDialog"
      :content="contentDialog"
      @affirm="confirmModel"
    ></generalConfirm>
    <Loading v-model="showLoading" text="加载中...">
      <!-- <div>中间内容</div> -->
    </Loading>
  </div>
</template>
  
  <script>
import { Toast } from "vant";
import NavBar from "@/components/NavBar.vue";
import { activationlist, activationuseextend } from "@/api/buy/index";
import generalConfirm from "@/components/publicDialog/generalConfirm.vue";
import Loading from "@/components/publicDialog/Loading.vue";
import { mapState, mapMutations } from "vuex";
export default {
  name: "Choosecloudphone",
  components: {
    NavBar,
    generalConfirm,
    Loading,
  },
  data() {
    return {
      result: [],
      continuation: {},
      cloudphonelist: [],
      cloudphone: [],
      userInstanceIds: [],
      jihuomalist: [],
      allChecked: false,
      showDialog: false,
      confimBtnLoading: false,
      contentDialog: "",
      showLoading: true,
    };
  },

  mounted() {
    this.cloudphone = JSON.parse(sessionStorage.getItem("selectedphonebeen"));
    this.jihuomalist = JSON.parse(sessionStorage.getItem("jihuomalist"));
    this.getactivationlist();
  },
  computed: {
    ...mapState("persistence", ["isActivationCode"]),
  },

  methods: {
    ...mapMutations("persistence", [
      "SET_ISACTIVATIONCODE",
      "SET_ACTIVATIONCODELIST",
    ]),
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    checkAll() {
      if (this.allChecked) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },

    wancheng() {
      this.showDialog = true;
      this.contentDialog = `共输入${this.isActivationCode.length}张激活码和${this.result.length}个设备，是否确认激活？`;
    },
    // 获取云手机列表
    async getactivationlist() {
      activationlist(this.$route.query.skuId)
        .then((res) => {
          this.showLoading = false;
          if (res.code == 200) {
            this.cloudphonelist = res.data;
            if (this.cloudphone) {
              // this.xunhuan();
            }
          } 
        })
        .catch(() => {
          this.showLoading = false;
        });
    },
    // 复选框默认选中
    xunhuan() {
      for (let i = 0; i < this.cloudphonelist.length; i++) {
        for (let j = 0; j < this.cloudphone.length; j++) {
          if (
            this.cloudphonelist[i].userInstanceId ==
            this.cloudphone[j].userInstanceId
          ) {
            this.result.push(this.cloudphonelist[i]);
          }
        }
      }
    },
    confirmModel() {
      if (this.result.length != 0) {
        // sessionStorage.setItem(
        //   "selectedphonebeen",
        //   JSON.stringify(this.result)
        // );
        // this.$router.push({ path: "/activationcodeusage" });
        if (this.result.length != 0) {
          this.userInstanceIds = [];
          for (let i = 0; i < this.result.length; i++) {
            this.userInstanceIds.push("" + this.result[i].userInstanceId);
          }
        }
        // if (this.result.length != 0) {
        //   for (let i = 0; i < this.cloudphonelist.length; i++) {
        //     this.userInstanceIds.push("" + this.result[i].userInstanceId);
        //   }
        // }
        let data = {
          activationCodes: this.isActivationCode,
          userInstanceIds: this.userInstanceIds,
          skuId: this.$route.query.skuId,
        };
        activationuseextend(data).then((res) => {
          if (res.code == 200) {
            this.SET_ACTIVATIONCODELIST(res.data);
            this.$router.push({
              path: "/activationResult",
            });
          }
        });
      }
    },
    changeModel() {
      this.showDialog = false;
    },
  },
};
</script>
  
  <style lang="less" scoped>
.choosecloudphone {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.main {
  margin: 10px 16px;
  flex: 1;
  .shebeiBox {
    background-color: transparent;
    .shebeiItem {
      margin-bottom: 12px;
      border-radius: 10px;
      .shebei_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 8px;
        img {
          width: 40px;
          height: 40px;
          border-radius: 20px;
        }
        .shebei_content {
          // margin-left: 16px;
          text-align: left;
          p {
            margin: 0;
            height: 22px;
            font-size: 13px;
            font-weight: 400;
            color: #999999;
            line-height: 22px;
          }
          .p1 {
            font-weight: 500;
            font-size: 15px;
            color: #505465;
          }
          .p2 {
            display: flex;
            align-items: center;
            .idIcon {
              width: 18px;
              height: 17px;
              margin-right: 4px;
            }
            .id {
              font-weight: 500;
              font-size: 10px;
              color: #b8bdcc;
            }
          }
        }
        .instanceItem {
          font-weight: 400;
          font-size: 11px;
          color: #a9adb6;
        }
      }
    }
  }
}
.footer {
  width: 100%;
  height: 60px;
  background: #fff;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  display: flex;
  justify-content: space-between;
  .allChecked {
    // display: flex;
  }
  p {
    flex: 1;
    height: 22px;
    font-size: 15px;
    text-align: left;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
    margin: 0;
    margin-top: 5px;
  }
  .jihuo {
    width: 99px;
    height: 44px;
    border: none;
    font-size: 18px;
    font-weight: 500;
    color: #ffffff;
    line-height: 22px;
    border-radius: 26px 26px 26px 26px;
    font-family: PingFang SC-Medium, PingFang SC;
  }
}
.contentBox {
  font-size: 14px;
  padding: 0 10px;
}
</style>